import LocalStorageService from '../../../utils/LocalStorageService'
import Router from 'next/router'

interface UTMData {
  utm_campaign: string;
  utm_medium: string;
  utm_source: string;
  utm_content: string;
  utm_term: string;
}

type QueryParams = Partial<UTMData>;

const DEFAULT_UTM_VALUE = "(none)";

const createDefaultUTMData = (): UTMData => ({
  utm_campaign: DEFAULT_UTM_VALUE,
  utm_medium: DEFAULT_UTM_VALUE,
  utm_source: DEFAULT_UTM_VALUE,
  utm_content: DEFAULT_UTM_VALUE,
  utm_term: DEFAULT_UTM_VALUE,
});

function removeUTMPayload(): void {
  LocalStorageService.removeItem('utm_payload_v2')
}

function formatUtmFromQuery(query: QueryParams): UTMData {
  return {
    utm_campaign: query?.utm_campaign ?? DEFAULT_UTM_VALUE,
    utm_medium: query?.utm_medium ?? DEFAULT_UTM_VALUE,
    utm_source: query?.utm_source ?? DEFAULT_UTM_VALUE,
    utm_content: query?.utm_content ?? DEFAULT_UTM_VALUE,
    utm_term: query?.utm_term ?? DEFAULT_UTM_VALUE,
  }
}

function setUTMPayload(): UTMData {
  try {
    const query = Router?.router?.query ?? {};
    const utmData = formatUtmFromQuery(query);
    LocalStorageService.setItem('utm_payload_v2', JSON.stringify(utmData));    
    return utmData;
  } catch (error) {
    console.error('Error setting UTM payload:', error);
    return createDefaultUTMData();
  }
}

function getUTMPayload(): UTMData {
  try {
    // Check if UTM data is available in localStorage
    const localStorageUTM = LocalStorageService.getItem('utm_payload_v2');
    if (localStorageUTM) {
      try {
        return JSON.parse(localStorageUTM) as UTMData;
      } catch (parseError) {
        console.error('Error parsing UTM data from localStorage:', parseError);
      }
    }

    // If no valid UTM data in localStorage, get from current query parameters
    const isValidUTM = validateQueryParamsContainsUTM();
    if (!isValidUTM) {
      return createDefaultUTMData();
    }
    return setUTMPayload();
  } catch (error) {
    console.error('Error retrieving UTM data:', error);
    return createDefaultUTMData();
  }
}

function validateQueryParamsContainsUTM(): boolean {
  const currentQuery = Router?.router?.query ?? {};
  const utmParams = ['utm_campaign', 'utm_medium', 'utm_source', 'utm_content', 'utm_term']
  
  if (!currentQuery || typeof currentQuery !== 'object' || Object.keys(currentQuery).length === 0) {
    return false
  }
  
  return utmParams.some(param => currentQuery[param] && currentQuery[param] !== '')
}

export {
  getUTMPayload,
  setUTMPayload,
  removeUTMPayload,
  validateQueryParamsContainsUTM
}
